import React, { useEffect, useState } from 'react';

import { Button, Select } from '~components';
import Icon, { faPlay } from '~components/icon';

interface ComponentProps {
  id: string;
  actionOptions: { value: string; label: string; minimum?: number }[];
  selectedIds: string[];
  onAction: (action: string) => void | Promise<void>;
  /** True while the chosen action is running: disables the action picker and shows a spinner on Go */
  loading?: boolean;
}

const BulkActions: React.FC<ComponentProps> = ({ id, selectedIds, onAction, actionOptions, loading = false }) => {
  const [selectedAction, setSelectedAction] = useState<string | null>(null);

  const selectionCount = selectedIds.length;
  const hasSelection = selectionCount > 0;

  const handleGo = () => {
    if (selectedAction) {
      onAction(selectedAction);
      setSelectedAction(null);
    }
  };

  // Filter options based on selection count and minimum requirement
  const availableOptions = actionOptions.filter((option) => {
    if (option.minimum !== undefined && selectionCount < option.minimum) {
      return false;
    }
    return true;
  });

  // Clear selectedAction if it's no longer in availableOptions
  useEffect(() => {
    if (selectedAction && !availableOptions.some((option) => option.value === selectedAction)) {
      setSelectedAction(null);
    }
  }, [selectedAction, availableOptions]);

  return (
    <div className="d-flex align-items-center mx-2">
      <Select
        id={id}
        name={id}
        className="me-2"
        size="sm"
        placeholder="Select bulk action..."
        options={availableOptions}
        value={selectedAction || undefined}
        onChange={(_, value) => setSelectedAction(value)}
        disabled={!hasSelection || loading}
      />
      <Button
        id={`${id}-go-button`}
        size="sm"
        disabled={!hasSelection || !selectedAction}
        loading={loading}
        onClick={handleGo}
      >
        <Icon className="me-2" icon={faPlay} />
        Go
      </Button>
    </div>
  );
};

export default BulkActions;
